import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import { listItemButtonClasses } from "@mui/joy/ListItemButton";
import { useLocation } from "react-router-dom";
import { useTranslation } from "../../i18n";
import { ComponentType } from "react";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import { Box, Divider } from "@mui/joy";
import LanguageToggle from "../../components/header/LanguageToggle";
import ProfileDropDown from "../../components/header/ProfileDropDown";
import TeamSelect from "../../components/TeamSelect";
import { NavItem } from "../../components/Navigation";
import HomeIcon from "@mui/icons-material/Home";
import { useUserMeQuery } from "../../__generated__/types-and-hooks";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import FactoryIcon from "@mui/icons-material/Factory";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import CategoryIcon from "@mui/icons-material/Category";
import ContactPageOutlinedIcon from "@mui/icons-material/ContactPageOutlined";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import SettingsIcon from "@mui/icons-material/SettingsRounded";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import PublicIcon from "@mui/icons-material/Public";

export interface NavItemProps {
  selected: boolean;
  to: string;
  title: string;
  icon: ComponentType<{ fontSize?: any; sx?: object }>;
}

export default function Navigation() {
  const t = useTranslation();
  const { pathname } = useLocation();
  const [, section] = pathname.split("/");

  const user = useUserMeQuery();
  let team = null;
  const teamEdges = user.data?.user_me.teamEdges ?? [];
  if (teamEdges.length === 1) {
    team = teamEdges[0].team;
  }
  const teamSlug = team?.slug;

  return (
    <Box
      sx={{
        height: "100%",
        minHeight: 0,
        overflow: "hidden auto",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        [`& .${listItemButtonClasses.root}`]: {
          gap: 1.5,
        },
      }}
    >
      <List
        size="sm"
        sx={{
          gap: 1,
          pt: 1,
          "--List-nestedInsetStart": { sm: "0px", lg: "30px" },
          "--ListItem-radius": (theme) => theme.vars.radius.sm,
        }}
      >
        <NavItem
          title={t("Home")}
          selected={!section}
          to={"/"}
          icon={(props) => <HomeIcon {...props} />}
        />
        <NavItem
          title={t("Network")}
          selected={section === "network"}
          to={"/network"}
          icon={(props) => <LanguageOutlinedIcon {...props} />}
        />
        <Divider
          sx={{
            textTransform: "uppercase",
            fontWeight: "md",
            color: "neutral.500",
            fontSize: "8px",
          }}
        >
          {t("TEAM")}
        </Divider>
        <ListItem>
          <TeamSelect />
        </ListItem>
        {team && (
          <>
            {team.kind === "AGENCY" && (
              <NavItem
                title={t("Inquiries")}
                selected={section === "inquiries"}
                to={`/${teamSlug}/inquiries`}
                icon={(props) => <PublicOutlinedIcon {...props} />}
                iconSelected={(props) => <PublicIcon {...props} />}
              />
            )}
            <NavItem
              title={t("Inspections")}
              selected={section === "inspections"}
              to={`/${teamSlug}/inspections`}
              icon={(props) => <FactCheckOutlinedIcon {...props} />}
              iconSelected={(props) => <FactCheckIcon {...props} />}
            />
            {team.kind === "BRAND" && (
              <NavItem
                title={t("SKU")}
                selected={section === "sku"}
                to={`/${teamSlug}/sku`}
                icon={(props) => <CategoryOutlinedIcon {...props} />}
                iconSelected={(props) => <CategoryIcon {...props} />}
              />
            )}
            {/* {team.kind === "BRAND" && (
              <NavItem
                title={t("PO")}
                selected={section === "purchase-orders"}
                to={`/${teamSlug}/purchase-orders`}
                icon={(props) => <ReceiptOutlinedIcon {...props} />}
                iconSelected={(props) => <ReceiptIcon {...props} />}
              />
            )} */}
            {team.kind === "BRAND" && (
              <NavItem
                title={t("Suppliers")}
                selected={section === "suppliers"}
                to={`/${teamSlug}/suppliers`}
                icon={(props) => <FactoryOutlinedIcon {...props} />}
                iconSelected={(props) => <FactoryIcon {...props} />}
              />
            )}
            {team.kind === "BRAND" && (
              <NavItem
                title={t("Contacts")}
                selected={section === "contacts"}
                to={`/${teamSlug}/contacts`}
                icon={(props) => <ContactPageOutlinedIcon {...props} />}
                iconSelected={(props) => <ContactPageIcon {...props} />}
              />
            )}
            <NavItem
              title={t("Chat")}
              selected={section === "chat"}
              to={`/${teamSlug}/chat`}
              icon={(props) => <ForumOutlinedIcon {...props} />}
            />
            <NavItem
              title={t("Settings")}
              selected={section === "settings"}
              to={`/${teamSlug}/settings`}
              icon={(props) => <SettingsOutlinedIcon {...props} />}
              iconSelected={(props) => <SettingsIcon {...props} />}
            />
          </>
        )}
      </List>
      <List
        size="sm"
        sx={{
          flexGrow: 0,
          m: 1,
        }}
      >
        <LanguageToggle />
      </List>
      <Divider />
      <List
        size="sm"
        sx={{
          flexGrow: 0,
          mt: 1,
          mb: 1,
        }}
      >
        <ListItem>
          <ProfileDropDown />
        </ListItem>
      </List>
    </Box>
  );
}
